'use client';
import { oneHub } from '@/types/oneHub';
import Image from 'next/image';
import { Tiro_Tamil, Noto_Sans } from 'next/font/google';
import Link from 'next/link';
const inter = Tiro_Tamil({
  weight: '400',
  subsets: ['tamil'],
});

const inter2 = Noto_Sans({
  weight: '400',
  subsets: ['latin'],
});

export default function PcBookItem(props: oneHub.IBookInfo) {
  return (
    <div className='flex flex-col items-center'>
      <div>
        <Link href={`/summary/${props._urlId}`}>
          <div className='w-[180px] h-[270px]'>
            <Image
              src={props.coverPath}
              width={180}
              height={270}
              alt={props.title}
              style={{
                objectFit: 'cover',
                width: '100%',
                height: '100%',
              }}
            />
          </div>
        </Link>
        <p className={`${ inter.className } pt-2 text-16-22`}>{ props.title }</p>
        <p className={ `${inter2.className} pt-1 text-[rgba(0,0,0,0.45)] text-[13px] leading-[18px]` }>{ props.author }</p>
      </div>
    </div>
  );
}
